import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=76e3e0a0&scoped=true&"
import script from "./TagsInput.vue?vue&type=script&lang=js&"
export * from "./TagsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e3e0a0",
  null
  
)

export default component.exports